<template>
  <div class="tooltip__dot">
    <div class="tooltip__icon">
      <span class="tooltip__locked">
        <!-- <div class="tooltip__locked-id">{{ dot.id }}</div> -->
        <span>{{ dot.tooltipText }}</span>
      </span>
    </div>
    <div
      v-if="dot.isAvailable"
      :class="{
        tooltip__popup: true,
        tooltip__popup_bottom: dot.position === 'bottom',
        tooltip__popup_left: dot.position === 'left',
        tooltip__popup_right: dot.position === 'right',
      }"
    >
      <!-- tooltip__popup_bottom: dot.id !== 6 && dot.id !== 2,
    tooltip__popup_left: dot.id === 6, -->
      <div v-show="step == 1" class="step-1">
        <div class="h4" v-html="dot.title" />
        <div class="h4 tooltip__text" v-html="dot.text" />
        <div v-if="!dot.custom_popup" class="tooltip-table">
          <div v-if="dot.floors" class="tooltip-table__row">
            <div class="tooltip-table__td">
              <span>Этажей</span>
            </div>
            <div class="tooltip-table__td">
              <span>{{ dot.floors.length }}</span>
            </div>
          </div>
          <!-- <div class="tooltip-table__row">
            <div class="tooltip-table__td">
              <span>
                {{ dot.isApartments ? "Лотов" : "Квартир" }}
                в&nbsp;продаже
              </span>
            </div>
            <div class="tooltip-table__td">
              <span>{{ flats }}</span>
            </div>
          </div> -->
        </div>
        <!-- <div v-if="flats && !dot.custom_popup" class="tooltip__button">
          <router-link
            class="btn btn-default btn-small w-100"
            :to="{ name: 'PlanSearch' }"
          >
            Выбрать квартиру
          </router-link>
        </div> -->
        <div v-if="flats && !dot.custom_popup" class="tooltip__button">
          <router-link
            class="btn btn-default btn-small w-100"
            :to="{ name: 'PlanSearch', query: { korpus: dot.id } }"
          >
            Выбрать квартиру
          </router-link>
        </div>
        <div class="tooltip__button">
          <button
            v-if="dot.custom_popup"
            class="btn btn-default btn-small w-100"
          >
            Узнать подробнее
          </button>
        </div>
        <div class="tooltip__button">
          <button
            v-if="dot.id === 6"
            class="btn btn-tour btn-small w-100"
            style="margin-top: 15px"
          >
            Смотреть 3Д-тур
          </button>
        </div>
      </div>
      <div v-if="current" v-show="step == 2" class="step-2">
        <div class="h4">Выберите этаж</div>
        <div class="tooltip__slider">
          <Slider
            v-model="current"
            :min="floorMinMax[0]"
            :max="floorMinMax[1]"
            :format="floorFilterFormat"
          />
        </div>
        <div class="tooltip__floorinfo" v-html="floorinfo" />
        <router-link
          v-if="hasFlats"
          class="tooltip__btn btn btn-default btn-small w-100"
          to="/"
        >
          Перейти к планировке
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Slider from "@vueform/slider";
import _forEach from "lodash/forEach";
import _toNumber from "lodash/toNumber";
import _minBy from "lodash/minBy";
import _maxBy from "lodash/maxBy";
import _groupBy from "lodash/groupBy";
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);
export default {
  components: {
    Slider,
  },
  inject: ["mq"],
  props: {
    dot: {
      type: Object,
      required: true,
    },
  },
  emits: ["close"],
  data() {
    return {
      step: 1,
      flats: 0,
      floors: [],
      floorMinMax: [null, null],
      current: null,
    };
  },
  computed: {
    hasFlats() {
      return !!this.floors.find((floor) => floor.id == this.current);
    },
    floorinfo() {
      let result = "";
      if (this.current) {
        let floor = this.floors.filter((el) => {
          return el.id == this.current;
        });
        if (floor[0] === undefined) {
          result = `На данный момент нет доступных квартир на&nbsp;${this.current} этаже.`;
        } else {
          const flatName = this.$filters.declOfNum(
            floor[0].flats,
            this.dot.isApartments
              ? ["лот", "лота", "лотов"]
              : ["квартира", "квартиры", "квартир"]
          );
          result = `В&nbsp;продаже <b>${floor[0].flats}
						${flatName}
						${this.$filters.squareFormat(
              floor[0].min
            )}&nbsp;-&nbsp;${this.$filters.squareFormat(floor[0].max)}</b>
						на&nbsp;${floor[0].id}&nbsp;этаже.`;
        }
      }
      return result;
    },
  },
  watch: {
    "dot.isActive"(isActive) {
      if (isActive) {
        this.step = 1;
      }
    },
  },

  async mounted() {
    try {
      if (this.dot.isAvailable) {
        const response = await axios.get(
          this.$endpoint +
            "building-objects/" +
            this.$project +
            "/properties?building=" +
            this.dot.id
        );
        const data = response.data.data.filter((flat) => {
          return flat.floor.number > 0;
        });

        this.flats = data.length;

        this.floorMinMax = [
          _minBy(data, "floor.number").floor.number,
          _maxBy(data, "floor.number").floor.number,
        ];

        this.current = this.floorMinMax[0];

        const result = [];
        const list = _groupBy(data, "floor.number");

        _forEach(list, (value, key) => {
          result.push({
            id: _toNumber(key),
            flats: value.length,
            min: _minBy(value, "layout.area").layout.area,
            max: _maxBy(value, "layout.area").layout.area,
          });
        });

        this.floors = result;
      }
    } catch (err) {
      //
    } finally {
      //
    }
  },
  methods: {
    floorFilterFormat: function (value) {
      return value.toFixed(0);
    },
    onCallback: function () {
      window.popupWithChats.showCallback({ title: "Узнать подробнее" });
    },
    toTour() {
      this.$vfm.show({
        component: "PopupPanorama",
        bind: {
          title: "3Д-тур",
          src: "https://biganto.ru/tour/59c7348e-67ff-4ac5-8545-a526e38eb910/",
        },
      });
    },
    smoothScroll(e) {
      const target = e.currentTarget.getAttribute("href");
      if (target && target.startsWith("#")) {
        e.preventDefault();
        const element = document.querySelector(target);
        if (element) {
          if (history.pushState) {
            history.pushState(null, null, target);
          } else {
            window.location.hash = target;
          }
          gsap.to(window, {
            scrollTo: {
              y: element,
              offsetY: 50,
            },
            duration: 1,
            ease: "power2.inOut",
          });
        }
      }
    },
  },
};
</script>


<style scoped>
@import "~@css/slider.css";
@import "~@vueform/slider/themes/default.css";

.tooltip__popup {
  border-radius: 20px;
}

.tooltip__slider {
  margin: 42px 0 16px;
}

.tooltip__slider :deep(.slider-base::before) {
  right: 0;
  left: 0;
}

.tooltip__popup::before,
.tooltip__popup::after {
  pointer-events: auto;
}

.step-1 .h4:not(.tooltip__text) {
  margin-bottom: 10px;
  color: #545863;
  font-size: 24px;
}

.tooltip__text {
  color: #ff0020;
  font-weight: 400;
  font-size: 16px;
  line-height: 110%;
  opacity: 0.76;
}

.tooltip__floorinfo {
  font-size: 16px;
}

.tooltip__btn {
  margin-top: 17px;
}

.tooltip__locked-id {
  display: inline-block;
  width: 24px;
  text-align: center;
}
/* @media (max-width: 1400px) and (min-width: 992px) {
} */
.tooltip__popup_bottom {
  top: 55px;
  bottom: auto;
}

.tooltip__popup_bottom::after {
  top: auto;
  bottom: 100%;
  border-color: rgb(255 255 255 / 0);
  border-bottom-color: #fff;
}

.tooltip__popup_left {
  bottom: -15px;
  left: -60px;
}

.tooltip__popup_left::after {
  left: 108px;
}

.tooltip__popup_right {
  top: -114px;
  bottom: auto;
  left: 231px;
}

.tooltip__popup_right::after {
  top: 103px;
  left: -11px;
  transform: rotate(90deg);
}

.btn-small {
  font-weight: 600;
  font-size: 18px;
}

a {
  color: currentColor;
  text-decoration: none;
}
</style>
